// 星春大吉 - 參加方法
'use client';

import { OFFICIAL_URL } from '@/common/constant';
import { downloadSeatDemo } from '@/common/eventUtil';

const LunarYearJoin = () => {
    return (
        <div className="space-y-[16px]">
            <div className="relative">
                {/* 參加方法 */}
                <img src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'join.png'} alt="join" />
                {/* 小怪獸 */}
                <img
                    className="absolute left-[-9%] bottom-[-23%] w-[108px] aspect-[1]"
                    src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'monster.png'}
                    alt="monster"
                />
            </div>

            {/* 下載按鈕 */}
            <button
                onClick={downloadSeatDemo}
                className="block w-[162px] mx-auto trans hover:opacity-[.7]"
            >
                <img
                    className="w-full"
                    src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'download.png'}
                    alt="download"
                />
            </button>
        </div>
    );
};

export default LunarYearJoin;
